export default {
  data() {
    return {
      id: null
    };
  },

  mounted() {
    this.id = `component-${this._uid}`;
  }
};



// WEBPACK FOOTER //
// src/mixins/uid.js